(() => {
  if (customElements.get('theme-loader')) return;
  class ThemeLoader extends HTMLElement {
    connectedCallback() {
      const progressBar = this.querySelector('.loader-progress-bar');
      const percentageText = this.querySelector('#loader-percentage');
      const body = document.body;
      const attr = this.getAttribute('duration');
      let duration = parseInt(attr, 10);
      if (!Number.isFinite(duration) || duration <= 0) {
        duration = 2000;
      }
      body.classList.add('loader-active');
      const start = performance.now();
      const finish = () => {
        if (progressBar) {
          progressBar.style.setProperty('--progress', '100%');
        }
        if (percentageText) {
          percentageText.textContent = 'Loading 100%';
        }
        this.classList.add('animate-top');
        body.classList.remove('loader-active');
        const agePopup = document.querySelector('[data-popup-type="age-verification"]');
        if (!(agePopup && agePopup.classList.contains('active'))) {
          body.classList.remove('overflow-hidden');
        }
        const removeSelf = () => this.remove();
        this.addEventListener('animationend', removeSelf, { once: true });
        this.addEventListener('transitionend', removeSelf, { once: true });
        setTimeout(removeSelf, 500);
      };
      const tick = (now) => {
        const elapsed = now - start;
        const percent = Math.min(100, (elapsed / duration) * 100);
        if (progressBar) {
          progressBar.style.setProperty('--progress', `${percent}%`);
        }
        if (percentageText) {
          percentageText.textContent = `Loading ${Math.floor(percent)}%`;
        }
        if (elapsed < duration) {
          requestAnimationFrame(tick);
        } else {
          finish();
        }
      };
      requestAnimationFrame(tick);
    }
  }
  customElements.define('theme-loader', ThemeLoader);
})();

// class themeLoader extends HTMLElement {
//   connectedCallback() {
//     const thisElement = this;
//     const progressBar = this.querySelector('.loader-progress-bar');
//     const percentageText = this.querySelector('#loader-percentage');
//     document.body.classList.add("loader-active");
//     const duration = 1500;
//     const finish = () => {
//       progressBar?.style.setProperty('--progress', '100%');
//       if (percentageText) percentageText.textContent = 'Loading 100%';

//       thisElement.classList.add('animate-top');
//       document.body.classList.remove("loader-active");

//       const agePopup = document.querySelector('[data-popup-type="age-verification"]');
//       if (!(agePopup && agePopup.classList.contains('active'))) {
//         document.body.classList.remove('overflow-hidden');
//       }
//     };
//     const tick = () => {
//       const now = performance.now();
//       const percent = Math.min(100, (now / duration) * 100);
//       progressBar?.style.setProperty('--progress', percent + '%');
//       if (percentageText) percentageText.textContent = `Loading ${Math.floor(percent)}%`;
//       if (percent < 100) {
//         requestAnimationFrame(tick);
//       } else {
//         finish();
//       }
//     };
//     requestAnimationFrame(tick);
//   }
// }
// customElements.define('theme-loader', themeLoader);
